export default function playVideo() {
    if(document.querySelector(".play-audio")) {
        let play = document.querySelector(".play-audio");

        play.addEventListener("click", () => {
            if(play.classList.contains("active")) {
                play.classList.remove("active");

                if(document.querySelector(".video__content")) {
                    let video = document.querySelector(".video__content video");

                    video.muted = false;
                }
            } else {
                play.classList.add("active");

                if(document.querySelector(".video__content")) {
                    let video = document.querySelector(".video__content video");

                    video.muted = true;
                }
            }
        });
    }

    if(document.querySelector(".modal__content .video__content")) {
        let playModal = document.querySelector(".play-video");
        let modalClose = document.querySelector(".modal__close");
        let modalBg = document.querySelector(".modal__bg");

        playModal.addEventListener("click", () => {
            document.querySelector(".video__content video").autoplay = true;
        });

        modalClose.addEventListener("click", () => {
            let video = document.querySelector(".video__content video");
            let videoSrc = video.src;

            video.src = "";
            video.autoplay = false;
            video.src = videoSrc;
        });

        modalBg.addEventListener("click", () => {
            let video = document.querySelector(".video__content video");
            let videoSrc = video.src;

            video.src = "";
            video.autoplay = false;
            video.src = videoSrc;
        });
    }
}
